<template>
  <div>
    <div class="page-title">New Registration Form</div>
    <Form v-model="form" :submit="create" btnText="Create Registration Form" />
  </div>
</template>

<script>
import Form from "./_form.registration-forms.page";

export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Registration Form",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.RegistrationForm.new();
      this.form = data;
    },
    async create() {
      await this.$api.RegistrationForm.create(this.form);
      this.$router.push("/widgets/registration-forms");
    },
  },
};
</script>

<style></style>
